import React, { PropTypes, Component } from 'react';
import { ContentStatus } from 'enums';
import Logo from 'common/Logo';
import SharePalette from 'common/social/SharePalette';
import UpcomingAlert from '@alias/UpcomingAlert';
import playable from '@alias/Playable';
import { getMinutesUntilStart, dateFormat } from 'lib/format';

const DEFAULT_DISPLAY_ALERT_UNTIL = 30; // minutes prior to the event startTime
const IS_BLACKED_OUT_MESSAGE = 'Not available in your area';

class ScheduleEventCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayAlert: false
        };
        this.toggleAlert = this.toggleAlert.bind(this);
    }

    getAlertEl(displayTime) {
        const { content } = this.props;
        if (this.state.displayAlert) {
            return (
                <UpcomingAlert
                    align="center"
                    animation="slide"
                    content={content}
                    displayTime={displayTime}
                    onClick={this.toggleAlert}
                    onClose={this.toggleAlert}
                />
            );
        }
        return null;
    }

    getDisplayTime() {
        const {
            content: { utc },
            dateFormat: dateFormatStr,
            userLocation,
            nextDayString
        } = this.props;
        const timeZone = userLocation && userLocation.timeZone;

        return dateFormat.getDateTimeString(
            utc,
            dateFormatStr,
            timeZone,
            'schedule-event',
            nextDayString
        );
    }

    shouldAlertOnClick() {
        const { content, alertThreshold } = this.props;
        if (content.status === ContentStatus.UPCOMING) {
            const minUntilStart = getMinutesUntilStart(content);
            return (minUntilStart <= 0 || minUntilStart >= alertThreshold);
        }
        return false;
    }

    toggleAlert(event) {
        event.preventDefault();
        this.setState({ displayAlert: !this.state.displayAlert });
    }

    render() {
        const {
            content,
            clickHandler,
            userIsBlackedOut,
            showLock
        } = this.props;

        const { id, name, source: sourceArg, subtitle: subtitleArg } = content;
        let source = sourceArg;
        let subtitle = subtitleArg;
        if (!source && subtitle) {
            const tmpArr = subtitle.split(' • ');
            source = tmpArr.shift();
            subtitle = tmpArr.join(' • ');
        }

        let footerText = subtitle;
        const subtitleClickHandler = null;

        if (userIsBlackedOut) {
            footerText = IS_BLACKED_OUT_MESSAGE;
            // it wasn't working before and not sure if the blackout map will always work, so disabled
            // subtitleClickHandler = blackoutClickHandler;
        }

        const keyClass = showLock ? ' icon-lock-solid-before' : '';
        const displayTime = this.getDisplayTime();
        // don't use the injected clickHandler if we should alert instead
        const handleClick = this.shouldAlertOnClick() ? this.toggleAlert : clickHandler;

        return (
            <article className="contentItem contentItem--module contentItem--hasAlert" data-id={id}>
                {this.getAlertEl(displayTime)}
                <header className="contentItem__header contentItem__header--module">
                    <div href="#" className="contentItem__header__wrapper">
                        <Logo iconHref={content.iconHref} className={'contentItem__logo'} />
                    </div>
                </header>
                <a onClick={handleClick}>
                    <section className="contentItem__content contentItem__content--module">
                        <div className={`collection_item_meta icon-font-before${keyClass}`}>
                            <div className="collection_item_truncate">
                                <span>{displayTime}</span>
                                <span>{source}</span>
                            </div>
                        </div>
                        <h1 className="contentItem__title">{name}</h1>
                    </section>
                </a>
                <footer className="contentItem__footer contentItem__footer--module">
                    <div onClick={subtitleClickHandler} className="metaData">
                        <span>{footerText}</span>
                    </div>
                    <SharePalette content={content} />
                </footer>
            </article>
        );
    }
}

ScheduleEventCard.propTypes = {
    alertThreshold: PropTypes.number,
    content: PropTypes.object,
    clickHandler: PropTypes.func,
    userIsBlackedOut: PropTypes.bool,
    dateFormat: PropTypes.string,
    showLock: PropTypes.bool,
    userLocation: PropTypes.object,
    nextDayString: PropTypes.string
};

ScheduleEventCard.defaultProps = {
    alertThreshold: DEFAULT_DISPLAY_ALERT_UNTIL
};

export { ScheduleEventCard as BaseScheduleEventCard };
export default playable(ScheduleEventCard);



// WEBPACK FOOTER //
// ./app/webapp/scheduleModule/ScheduleEventCard.js